import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoughNotation } from "react-rough-notation";

const TeamMemberDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showContact, setShowContact] = useState(false);
  
  // Ensure we have member data, otherwise redirect
  if (!location.state?.member) {
    navigate('/team');
    return null;
  }

  const { member } = location.state;

  const handleEmailClick = () => {
    window.location.href = `mailto:${member.email}`;
  };

  const handleContactClick = () => {
    setShowContact(prev => !prev);
  };

  return (
    <div className="w-full max-w-7xl mx-auto px-4 py-24">
      {/* Two Column Layout */}
      <div className="flex flex-col lg:flex-row gap-12">
        {/* Left Column - Content */}
        <div className="flex-1 space-y-8">
          <div>
            <h1 className="text-5xl font-arial-rounded font-bold text-primary mb-2">
              <RoughNotation 
                type="highlight" 
                show={true}
                color="rgba(85, 11, 96, 0.3)"
                animationDuration={800}
                iterations={1}
                multiline={true}
              >
                {member.name}
              </RoughNotation>
            </h1>
            <h2 className="text-2xl font-arial-rounded font-bold text-primary mb-6">
              {member.position}
            </h2>
            
            <div className="mb-8">
              <p className="text-primary italic text-lg whitespace-pre-line">
                "{member.moto_line}"
              </p>
            </div>
          </div>

          <div>
            <p className="text-gray-800 mb-6">
              {member.description}
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-primary mb-4">Career Highlights</h3>
            <ul className="space-y-4">
              {member.career_highlights.map((highlight, index) => (
                <li key={index} className="flex">
                  <span className="mr-2">•</span>
                  <span className="whitespace-pre-line">{highlight}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-primary mb-4">Outside of Work</h3>
            <p className="text-gray-800">
              {member.outside_of_work}
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-primary mb-4">Superpower</h3>
            <p className="text-gray-800">
              {member.super_power}
            </p>
          </div>
        </div>

        {/* Right Column - Image and Contact */}
        <div className="lg:w-1/3">
          <div className="relative w-full max-w-md mx-auto mb-8">
            {/* Decorative circles */}
            {/*
            <div className="absolute w-48 h-48 rounded-full bg-primary/20 -left-4 -top-4 z-0" />
            <div className="absolute w-56 h-56 rounded-full bg-yellow-400/20 -right-2 top-1/2 -translate-y-1/2 z-0" />
            <div className="absolute w-36 h-36 rounded-full bg-green-500/20 -bottom-4 -left-2 z-0" />
            */}
            {/* Image container */}
            <div className="relative aspect-[4/5] overflow-hidden rounded-lg z-10">
              <img
                src={member.image_url}
                alt={member.name}
                className="h-full w-full object-cover object-center"
              />
            </div>
          </div>

          <div className="space-y-4 max-w-md mx-auto">
            <button
              className="w-full bg-transparent py-3 px-6 text-primary text-lg font-medium border-2 border-primary rounded-full hover:bg-primary hover:text-white transition-colors duration-200 hover:scale-102 active:scale-98"
              onClick={handleEmailClick}
            >
              Send Email Enquiry
            </button>
            
            <button 
              className="w-full bg-transparent py-3 px-6 text-primary text-lg font-medium border-2 border-primary rounded-full hover:bg-primary hover:text-white transition-colors duration-200 hover:scale-102 active:scale-98"
              onClick={handleContactClick}
            >
              {showContact ? member.contact_number || 'Not Available' : 'Show Contact Number'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberDetail;